module.exports = __webpack_public_path__ + "img/yoga.290b1c6a.jpg";